<template>
  <v-dialog
    v-model="dialog"
    persistent
    fullscreen
  >
    <template v-slot:activator="{ on: dialog }">
      <v-btn
        icon
        color="primary"
        v-on="{ ...dialog}"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <v-container
      class="fill-height white-backgroud"    
      fluid
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="7"
        >
          <v-card>
            <v-card-title class="white-color green-background">
              {{ exam.name }} 
            </v-card-title>
       
            <v-row class="ml-1">
              <v-col cols="10">
                <v-row>
                  <v-col cols="12">
                    <span class="font-weight-bold">Name: </span>{{ attempt.employee.person.name }}
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0"
                  >
                    <span class="font-weight-bold">Duration: </span>{{ attempt.duration?attempt.duration +' minute' :'Did not complete exam' }}
                  </v-col>
                  <v-col cols="12">
                    <span class="font-weight-bold">Exam Taken On: </span>{{ $moment(attempt.created_at, 'YYYY-MM-DD HH:mm:ss').format('D MMM YYYY hh:mm A') }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="2"
                class="ma-auto text-center font-xx-large"
              >
                {{ totalMarks }}
              </v-col>
            </v-row>

            <v-divider />

            <v-col
              cols="12"
              class="scrollbar scroll-container"
            >
              <v-card
                v-for="(item,index) of attempt.exam_attempt_answers"
                :key="index"
              >
                <v-card-title
                  class="pb-0"
                  v-html="item.exam_question.content"
                />
                <v-card-text
                  v-for="(answer,index) in item.exam_question.answer_choices"
                  :key="index"
                  class="py-0"
                >
                  <div v-if="item.exam_question.question_type_id === 1">
                    <div
                      :class="answerLabel(item,answer)"
                      class="px-1"
                    >
                      {{ String.fromCharCode(97 + answer.index).toUpperCase() }}.{{ answer.content }}
                    </div>
                  </div>

                  <div v-if="item.exam_question.question_type_id === 2">
                    <span class="font-weight-bold">ANS:</span> {{ item.structure_answer }}
                    <div class="italic">
                      <span class="font-weight-bold color-dark">SUGGESTED ANS:</span> {{ answer.content }}
                    </div> 
                  </div>
                </v-card-text>
                <div
                  v-if="item.exam_question.question_type_id === 1"
                  class="px-4 pb-4 italic"
                >
                  <span class="font-weight-bold font-14">CORRECT ANS:</span> 
                  {{ String.fromCharCode(97 + item.exam_question.answer_choices[item.exam_question.answer_index].index).toUpperCase() }}.{{ item.exam_question.answer_choices[item.exam_question.answer_index].content }}
                </div> 

                <v-card-actions
                  v-if="item.structure_answer"
                  class="py-0"
                >
                  <v-spacer />
                  <v-text-field
                    v-model="item.mark"
                    v-validate="{
                      required:true,
                      negativeValue:item,
                      exceedMaxMarks:item
                    }"
                    :name="'mark' + index"
                    data-vv-as="mark"
                    :error-messages="errors.collect('mark' + index)"
                    type="number"
                    label="Marks"
                    class="text-field-width remove-spinner"
                    solo
                  /><span class="mt-n6 pl-2">/{{ item.exam_question.mark }}%</span>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-divider />

            <v-col
              class="text-right"
              cols="12"
            >
              <v-spacer />
              <v-btn
                text
                @click="dialog = false"
              > 
                Cancel
              </v-btn>
              <v-btn
                :loading="submitProgressing"
                color="success"
                @click="submit"
              >
                Submit
              </v-btn>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      attempt: {
        type: Object,
        required: true,
      },
      exam: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        submitProgressing: false,
      }
    },
    computed: {
      totalMarks () {
        let totalMarks = 0
        let markGained = 0

        this.attempt.exam_attempt_answers.map(answer => {
          markGained = markGained + parseInt(answer.mark ? (isNaN(answer.mark) ? parseInt(answer.mark) : answer.mark) : 0)
          totalMarks = totalMarks + answer.exam_question.mark
        })
      
        return ((markGained / totalMarks) * 100).toFixed(2) + '%'
      },
    },

    watch: {
      dialog (value) {
        if (!value) {
          this.$resetData() 
          this.$validator.reset()          
        } else {
          this.$validator.extend('negativeValue', {
            getMessage (field, args) {
              return 'Mark cannot be negative'
            },
            validate (value, args) {
              return value >= 0 
            },
          })
          this.$validator.extend('exceedMaxMarks', {
            getMessage (field, args) {
              return 'Exceed Maximum Mark'
            },
            validate (value, args) {
              return !!(value <= args.exam_question.mark)
            },
          })
        }
      },
    },
    methods: {
      answerLabel (item, answer) {
        return item.answer_index === answer.index ? item.answer_index === item.exam_question.answer_index ? 'correct-answer' : 'wrong-answer' : ''
      },
      submit () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.submitProgressing = true
            this.$api.examAttemptAnswers().update(this.attempt.id, this.prepareFormData())
              .then(res => {
                this.submitProgressing = false
                this.$emit('updated')
                this.$snack({ message: 'Marks Updated Successfully' })
                this.dialog = false
              })
          })
      },
      prepareFormData () {
        let result = []

        this.attempt.exam_attempt_answers.map(answer => {
          if (answer.structure_answer) {
            result.push({ exam_question_id: answer.exam_question_id, mark: answer.mark })
          }
        })

        return { marks: result }
      },
    },
  }
</script>

<style scoped>
.white-backgroud{
  background:white
}
.green-background{
  background:#5cb860;
}
.white-color{
  color:white;
}
.color-dark{
  color:#000000DE
}
.correct-answer{
  background-color: #ccffcc;
}
.wrong-answer{
  background-color: #ff9999;
}
.scrollbar::-webkit-scrollbar {
  width: 3px !important; 
}
.scrollbar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
.scrollbar::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}
.scrollbar::-webkit-scrollbar-thumb:hover {
  background:  #555; 
}
.italic{
  font-style: italic;
}
.text-field-width{
  max-width:160px
}
.scroll-container{
  max-height:500px;
  overflow-y:scroll
}
.font-14{
  font-size: 14px;
}
.font-xx-large{
  font-size:xx-large
}
/* Chrome, Safari, Edge, Opera */
.remove-spinner >>> ::-webkit-outer-spin-button,
.remove-spinner >>> ::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

</style>
